export interface AppInfo {
  readonly tag: string;
  readonly pipelineId: string;
}
// Gets stamped by CI
export const appInfo: AppInfo = {
  pipelineId: "211504",
  tag: "3.0.0",
};
